export class Stock {
    constructor(props) {
        Object.assign(this, props);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Stock/Model.ts
// module id = 339
// module chunks = 0